import { useCallback, useEffect, useState } from 'react';
import apiClient from '../requests/api/apiClient';
import { SensorSchema } from '../requests/api/apiTypes';

function useSensors(selectedFarmId: string) {
  const [sensors, setSensors] = useState<SensorSchema[]>([]);

  const fetchSensors = useCallback(async () => {
    if (selectedFarmId) {
      try {
        const response = await apiClient.sensors.sensorsByFarmId(
          selectedFarmId,
        );
        setSensors(response?.data?.sensors ?? []);
      } catch {
        setSensors([]);
      }
    }
  }, [selectedFarmId]);

  useEffect(() => {
    fetchSensors();
  }, [fetchSensors]);

  return { sensors, refetchSensors: fetchSensors };
}

export default useSensors;
